var map = {
	"./abc.svg": 391,
	"./baitiao.svg": 3663,
	"./bjb.svg": 516,
	"./bjrcb.svg": 3275,
	"./boc.svg": 5009,
	"./boca.svg": 500,
	"./ccb.svg": 1023,
	"./ceb.svg": 3109,
	"./cgb.svg": 2029,
	"./citi.svg": 2099,
	"./cmb.svg": 3804,
	"./cmbc.svg": 6859,
	"./default.svg": 3694,
	"./gcb.svg": 2196,
	"./hsbc.svg": 5455,
	"./huabei.svg": 9894,
	"./icbc.svg": 6369,
	"./nbb.svg": 5532,
	"./pab.svg": 3650,
	"./psbc.svg": 3317,
	"./spdb.svg": 3618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6134;